export default "__VITE_ASSET__mP22EIQH__"